import Vue from 'vue'

export const actionColumn = (action = Vue.prototype.$t('actions')) => ({
    title: action,
    type: 'action'
});

export const nameColumn = () => textColumn(Vue.prototype.$t('name'), 'name');

export const textColumn = (title, key) => ({
    title,
    type: 'text',
    key
});

export const objectColumn = (title, base, callback) => ({
    title,
    type: 'object',
    key: base,
    modifier: callback
});

export const htmlColumn = (title, key, callback) => ({
    title,
    type: 'custom-html',
    key,
    modifier: callback
})